<p-dialog 
  header="Delete Static DHCP Lease"
  [visible]="visible"
  (visibleChange)="visibleChange.emit($event)"
  [style]="{ width: '50vw' }"
  (onHide)="onCloseDialog()">

  <p>Do you want to delete the following Static DHCP leases ?</p>
  <ul class="one-column">
    <li *ngFor="let dchp of dhcpToBeRemoved">
      <p><b>TAG:</b> {{ dchp.set_tag }} <b>Mac Address:</b> {{ dchp.hwaddr }}</p>
    </li>
  </ul>

  <ng-template pTemplate="footer">
    <p-button icon="fas fa-trash"
              (onClick)="delete()"
              label="Delete"
              styleClass="p-button-danger">
    </p-button>
  </ng-template>

</p-dialog>
